'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard.fieldadmin', {
            url: '/fieldadmin',
            templateUrl: 'dashboard-admin/dashboard-admin.html',
            controller: 'dashboardAdminCtrl as ctrl',
            resolve: {},
            data: {
                authorizedRoles: ['fieldAdmin']
            }
        });
};
